export const truncateText = (string: string, length = 10, suffix = "...") => {
  if (string.length > length) {
    const ending = length - suffix.length;

    return string.substring(0, ending) + suffix;
  } else {
    return string;
  }
};

export const formatDate = (date: string) => {
  const [year, month, day] = date.split("-").map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  return utcDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
};
